import { Dispatch, SetStateAction, useEffect, useState } from 'react';

export type UseModalHelperReturnType = {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
};

export const useModalHelper = (initialValue = false): UseModalHelperReturnType => {
  const [isOpen, setOpen] = useState<boolean>(initialValue);

  useEffect(() => {
    setOpen(initialValue);
  }, [initialValue]);

  const open = () => {
    setOpen(true);
  };

  const close = () => {
    setOpen(false);
  };

  const toggle = () => {
    setOpen((open) => !open);
  };

  return { isOpen, open, close, toggle, setOpen };
};
